import React, {
  useEffect,
  useState,
  useCallback,
  Suspense,
} from "react";
import { Link, useNavigate } from "react-router-dom";
import Card from "react-bootstrap/Card";
import HeadingBanner from "../components/HeadingBanner";
import { Alert, Container, Row, Col, Modal, Button } from "react-bootstrap";
import {
  formatAladdinAvailabilityDate,
  useAladdinExportAvailability,
} from "../contexts/AladdinExportAvailabilityContext";
import {
  whoami,
  getClasses,
  getTeachers,
  getSchools,
  shareClass,
  updateClassOwnerId,
  getTrialistsBySchool,
  createTrialistBySchoolid,
  getCountryGrades,
  hasTeacherSubmittedClassNumbers,
  createClassConversionMethod,
  getClassConversionMethods,
  createSchoolmis,
  getSchoolmisBySchoolId,
  getScreeningWindowStatuses,
  getPilotBySchoolId,
  getCountryId,
  getMessageByMessageId,
} from "../services/APIClient";
// Import the new class number confirmation API calls
import {
  checkSchoolConfirmation,
  submitClassNumberConfirmation,
} from "../services/APIClient";
import { Fallback } from "../services/SpinnerComponent";
import "../components/ClassCard.css";
import "../components/MasterDashCards.css";

import OrientationPrompt from "../components/OrientationPrompt";
import useAcademicYearOptions from "../utils/useAcademicYearOptions";

// Lazy Loaded Components
const LeftPanel = React.lazy(() => import("../components/LeftPanel"));
const AdditionalColleaguesButtonMD = React.lazy(() =>
  import("../components/AdditionalColleaguesButtonMD")
);
const AdditionalColleaguesButtonMD2 = React.lazy(() =>
  import("../components/AdditionalColleaguesButtonMD2")
);
// Invite a School is retained for possible restoration.
// const ReferAFriendButton = React.lazy(() =>
//   import("../components/ReferFriendsButton")
// );
const IntroVideoButton = React.lazy(() =>
  import("../components/IntroVideoButton")
);
const AlpacaInfoGesture = React.lazy(() =>
  import("../components/AlpacaInfoGesture")
);

const FreeTrialBanner = React.lazy(() =>
  import("../components/FreeTrialBanner")
);

const VideoModal = React.lazy(() =>
  import("../components/VideoModal")
);

const ReceivedListModal = React.lazy(() =>
  import("../components/ReceivedListModal")
);

const ClassTransitionModal = React.lazy(() =>
  import("../components/ClassTransitionModal")
);

const ClassNumberModal = React.lazy(() =>
  import("../components/ClassNumberModal")
);

const buttonStyle = {
  // width: '80%',
  padding: '16px 24px',
  fontSize: '2.5vh',
  fontWeight: '600',
  backgroundColor: '#FF6B35',
  color: '#FFFFFF',
  border: 'none',
  borderRadius: '12px',
  cursor: 'pointer',
  boxShadow: '0 4px 12px rgba(255, 107, 53, 0.3)',
  transition: 'none',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  outline: 'none',
  marginBottom: '1%',
  width: '100%'
};


function MasterDashboard({ asOfDate }) {
  const {
    globalEnabled: aladdinGlobalEnabled,
    navigationAvailable: aladdinNavigationAvailable,
    nextUpcoming: aladdinNextUpcoming,
  } = useAladdinExportAvailability();
  const [schoolid, setSchoolid] = useState(null);
  const [teacherid, setTeacherid] = useState(null);
  const [name, setName] = useState("");
  const [teachers, setTeachers] = useState(null);
  const [teacherRoles, setTeacherRoles] = useState([]);
  const [gradeLevelOptions, setGradeLevelOptions] = useState([]);
  const [firstname, setFirstname] = useState(null);
  const [speechText, setSpeechText] = useState(null);
  const [classes, setClasses] = useState([]);
  const [classid, setClassid] = useState([]);
  const [rollNumber, setRollNumber] = useState(null);
  const [teacherEmail, setTeacherEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);

  // Class Number Confirmation Modal States
  const [showClassNumberModal, setShowClassNumberModal] = useState(false);

  const [trialistDetails, setTrialistDetails] = useState(null);
  const [freeDaysLeft, setFreeDaysLeft] = useState(null);
  const [showTrialEndedModal, setShowTrialEndedModal] = useState(false);
  const { expired = false, purchased = false, purchased_2425 = false, purchased_2526 = false } = trialistDetails || {};

  const [showSeniorInfantModal, setShowSeniorInfantModal] = useState(false);
  const [isSeniorInfantTeacher, setIsSeniorInfantTeacher] = useState(false);
  const [classNumberModalResolved, setClassNumberModalResolved] = useState(false);
  const [mixReassignSubmitting, setMixReassignSubmitting] = useState(false);

  const [showSeniorInfantReceivedModal, setShowSeniorInfantReceivedModal] = useState(false);
  const [receivedSubmissionData, setReceivedSubmissionData] = useState(null);

  const [showMisSystemModal, setShowMisSystemModal] = useState(false);
  const [misSystemModalResolved, setMisSystemModalResolved] = useState(false);
  const [selectedMisSystem, setSelectedMisSystem] = useState('');
  const [misSystemSubmitting, setMisSystemSubmitting] = useState(false);
  const [misSystemError, setMisSystemError] = useState('');
  const [misSystemSuccess, setMisSystemSuccess] = useState('');
  const [countryid, setCountryid] = useState(null);


  const [existingConversionMethods, setExistingConversionMethods] = useState([]);
  const [pilotData, setPilotData] = useState(null);
  const [screeningWindowData, setScreeningWindowData] = useState(null);
  const [homeMessage, setHomeMessage] = useState(null);
  const DEFAULT_COUNTRY_ID = '07d45b79-24b1-435f-b82a-93861b23a86e';

  const isPilot = pilotData && pilotData.length > 0 && pilotData[0].active;

  const [currentAcademicYear] = useAcademicYearOptions({ asOfDate });
  const currentAcademicYearStorage = currentAcademicYear?.storage;

  // const misSystemOptions = [
  //   { value: 'Aladdin', label: 'Aladdin' },
  //   { value: 'Arbor', label: 'Arbor' },
  //   { value: 'SIMS', label: 'SIMS' },
  //   { value: 'SchoolPod', label: 'SchoolPod' },
  //   { value: 'VSWare', label: 'VSWare' },
  //   { value: 'Other', label: 'Other' }
  // ];

  const [isPortrait, setIsPortrait] = useState(
    window.matchMedia("(orientation: portrait)").matches
  );
  const [sharedClassId, setSharedClassId] = useState(null);

  const navigate = useNavigate();

  // useEffect(() => {
  //   const checkMisSystemConfirmation = async () => {
  //     if (schoolid && teacherid && classNumberModalResolved && !showClassNumberModal) {
  //       try {
  //         // Check if MIS system has already been submitted for this school
  //         const existingMisRecords = await getSchoolmisBySchoolId(schoolid);

  //         if (existingMisRecords && existingMisRecords.length > 0) {
  //           // MIS system already recorded, mark as resolved
  //           setMisSystemModalResolved(true);
  //         } else {
  //           // No MIS system recorded, show modal
  //           setShowMisSystemModal(true);
  //         }
  //       } catch (error) {
  //         console.error("Error checking MIS system confirmation:", error);
  //         // On error, mark as resolved to prevent blocking other modals
  //         setMisSystemModalResolved(true);
  //       }
  //     }
  //   };

  //   checkMisSystemConfirmation();
  // }, [schoolid, teacherid, classNumberModalResolved, showClassNumberModal]);

  // const handleMisSystemSubmit = async () => {
  //   if (!selectedMisSystem) {
  //     setMisSystemError('Please select a MIS system.');
  //     return;
  //   }

  //   setMisSystemSubmitting(true);
  //   setMisSystemError('');
  //   setMisSystemSuccess('');

  //   try {
  //     await createSchoolmis({
  //       teacherid: teacherid,
  //       schoolid: schoolid,
  //       mis_system: selectedMisSystem
  //     });

  //     setMisSystemSuccess('Thank you! MIS system information saved successfully.');

  //     setTimeout(() => {
  //       setShowMisSystemModal(false);
  //       setMisSystemModalResolved(true);
  //     }, 1500);

  //   } catch (error) {
  //     console.error("Error submitting MIS system:", error);
  //     setMisSystemError('Failed to save MIS system information. Please try again.');
  //   } finally {
  //     setMisSystemSubmitting(false);
  //   }
  // };

  // const handleMisSystemDontKnow = () => {
  //   // Close modal without saving - user doesn't know their MIS system
  //   setShowMisSystemModal(false);
  //   setMisSystemModalResolved(true);
  // };

  // const handleCloseMisSystemModal = () => {
  //   // Allow closing only if there's a success message or error, or if "Don't Know" was clicked
  //   if (misSystemSuccess || misSystemError || misSystemModalResolved) {
  //     setShowMisSystemModal(false);
  //     if (!misSystemModalResolved) {
  //       setTimeout(() => {
  //         setMisSystemModalResolved(true);
  //       }, 100);
  //     }
  //   }
  // };

  useEffect(() => {
    const initialize = async () => {
      try {
        const savedSharedClassId = localStorage.getItem("sharedClassId");

        if (savedSharedClassId) {
          setSharedClassId(savedSharedClassId);
        }

        const whoamiResponse = await whoami();
        const { schoolid, id, name, additionalRoles, countryid } =
          whoamiResponse.data.stakeholder;

        // console.log('🔍 Destructured values:', { schoolid, id, name, additionalRoles, countryid });

        // setCountryid(countryid);
        // console.log('✅ Set countryid to:', countryid);

        // The role-selection redirect (forcing a stale/roleless teacher to
        // /profile) is handled centrally by RoleSelectionContext / ProtectedRoute
        // in index.js, which gates every route - not just this one.
        setSchoolid(schoolid);
        setTeacherid(id);
        setName(name);
        setTeacherEmail(whoamiResponse.data.email);
        setTeacherRoles(additionalRoles);

        console.log(countryid, "Country ID set in MasterDashboard");
        const gradesResponse = await getCountryGrades(countryid);
        setGradeLevelOptions(gradesResponse);

      } catch (error) {
        console.error("Error during initialization:", error);
      }
    };

    initialize();
  }, [navigate]);

  useEffect(() => {
    if (schoolid) {
      console.log('🔍 Fetching countryid for schoolid:', schoolid);
      getCountryId(schoolid)
        .then((response) => {
          if (response.countryId) {
            console.log('✅ Country ID response:', response);
            setCountryid(response.countryId);
          } else {
            console.warn("⚠️ No country ID found for school:", response.message);
            setCountryid(null);
          }
        })
        .catch((error) => {
          console.error("❌ Failed to fetch country ID:", error);
          setCountryid(null);
        });
    }
  }, [schoolid]);

  // Fetch the home message from the database
  useEffect(() => {
    if (countryid) {
      getMessageByMessageId(countryid, 'home_message')
        .then((msg) => {
          if (msg) {
            setHomeMessage(msg);
          }
        })
        .catch((error) => {
          console.error('Failed to fetch home message:', error);
        });
    }
  }, [countryid]);

  // Check for class number confirmation requirement
  // useEffect(() => {
  //   const checkClassNumberConfirmation = async () => {
  //     if (schoolid && teacherid) {
  //       try {
  //         // First check if this teacher has already submitted
  //         const teacherSubmissionStatus = await hasTeacherSubmittedClassNumbers(teacherid, schoolid);

  //         // If teacher has already submitted, mark as resolved and don't show modal
  //         if (teacherSubmissionStatus.hasSubmitted) {
  //           setClassNumberModalResolved(true);
  //           return;
  //         }

  //         // Otherwise check if school confirmation is needed
  //         const confirmationStatus = await checkSchoolConfirmation(schoolid);
  //         if (!confirmationStatus.hasConfirmation) {
  //           setShowClassNumberModal(true);
  //           // Don't mark as resolved yet - wait for user action
  //         } else {
  //           // School already has confirmation, mark as resolved
  //           setClassNumberModalResolved(true);
  //         }
  //       } catch (error) {
  //         console.error("Error checking class number confirmation:", error);
  //         // On error, mark as resolved to prevent blocking other modals
  //         setClassNumberModalResolved(true);
  //       }
  //     }
  //   };

  //   checkClassNumberConfirmation();
  // }, [schoolid, teacherid]);

  useEffect(() => {
    if (schoolid) {
      Promise.all([getTeachers(schoolid), getClasses(), getSchools()])
        .then(([teachersResponse, classesResponse, schoolsResponse]) => {
          setTeachers(teachersResponse);
          setClasses(classesResponse);
          setClassid(classesResponse.id);

          const matchingSchool = schoolsResponse.data.find(
            (school) => school.id === schoolid
          );

          if (matchingSchool) {
            setRollNumber(matchingSchool.rollnumber);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [schoolid]);

  useEffect(() => {
    if (name) {
      setFirstname(name.split(" ")[0]);
    }
  }, [name]);

  useEffect(() => {
    setSpeechText(
      `Hello ${firstname}, let's start by setting up a class. Click 'Classrooms' to begin or use the button above my head to explore the Dashboard.`
    );
  }, [firstname]);

  useEffect(() => {
    if (sharedClassId && teacherid) {
      shareClass(sharedClassId, teacherid, true)
        .then(() => updateClassOwnerId(sharedClassId, teacherid))
        .then(() => {
          localStorage.removeItem("sharedClassId");
        })
        .catch((error) => {
          console.error("Error sharing or updating class owner ID:", error);
        });
    }
  }, [sharedClassId, teacherid]);

  useEffect(() => {
    const fetchTrialistDetails = async () => {
      try {
        const response = await getTrialistsBySchool(schoolid);
        if (response.length > 0) {
          const details = response[0];
          console.log(details)
          setTrialistDetails(details);

          const currentDate = new Date();
          const endDate = new Date(details.end_date);
          const daysLeft = Math.ceil(
            (endDate - currentDate) / (1000 * 60 * 60 * 24)
          );
          setFreeDaysLeft(daysLeft > 0 ? daysLeft : 0);
        } else {
          const trialid = "1ed3aa96-d938-46a0-85bc-9fb98529c529"; // Static trialid
          const trialistData = await createTrialistBySchoolid(
            schoolid,
            trialid
          );
          setTrialistDetails(trialistData);

          const currentDate = new Date();
          const endDate = new Date(trialistData.end_date);
          const daysLeft = Math.ceil(
            (endDate - currentDate) / (1000 * 60 * 60 * 24)
          );
          setFreeDaysLeft(daysLeft > 0 ? daysLeft : 0);
        }
      } catch (error) {
        console.error("Failed to fetch trialist details:", error);
      }
    };

    if (schoolid) {
      fetchTrialistDetails();
    }
  }, [schoolid]);


  // const handleClassNumberSubmit = async (submissionData) => {
  //   const fullSubmissionData = {
  //     ...submissionData,
  //     teacherid: teacherid,
  //     schoolid: schoolid,
  //   };

  //   const result = await submitClassNumberConfirmation(fullSubmissionData);

  //   // Mark as resolved immediately on success - this triggers the next modal
  //   setClassNumberModalResolved(true);

  //   return result;
  // };

  // const handleCloseClassNumberModal = () => {
  //   setShowClassNumberModal(false);
  // };


  const handleCloseTrialEndedModal = () => {
    setShowTrialEndedModal(false);
  };

  const handleSENCOView = useCallback(() => {
    navigate("/sencoresults/detail", {
      state: {
        teachers,
        name,
        gradeLevelOptions,
        teacherid,
        schoolid,
      },
    });
  }, [navigate, teachers, name, gradeLevelOptions, teacherid, schoolid]);

  useEffect(() => {
    const handleOrientationChange = () => {
      setIsPortrait(window.innerWidth < window.innerHeight);
    };

    window.addEventListener("resize", handleOrientationChange);

    return () => {
      window.removeEventListener("resize", handleOrientationChange);
    };
  }, []);

  useEffect(() => {
    console.log('🔍 Senior Infant useEffect triggered');
    console.log('📊 Dependencies changed:', {
      schoolid,
      teacherid,
      teacherRolesLength: teacherRoles.length,
      classNumberModalResolved,
      showClassNumberModal,
      misSystemModalResolved,
      showMisSystemModal,
      trialistDetails: !!trialistDetails
    });

    const checkIfSeniorInfantTeacher = async () => {
      console.log('🔍 Senior Infant Check Started');

      // Only proceed if class number modal has been resolved AND is not currently showing
      if (!classNumberModalResolved || showClassNumberModal || !misSystemModalResolved || showMisSystemModal) {
        console.log('⏳ Waiting for modals to be resolved first', {
          classNumberModalResolved,
          showClassNumberModal,
          misSystemModalResolved,
          showMisSystemModal
        });
        return;
      }

      // Need trialist details to determine if new/old customer
      if (!trialistDetails) {
        console.log('⏳ Waiting for trialist details to be loaded');
        return;
      }

      if (schoolid && teacherid && teacherRoles.length > 0) {
        console.log('✅ Required data exists, proceeding with check');

        try {
          // Check if this is a new customer based on start_date
          const cutoffDate = new Date('2025-07-31T23:59:59Z');
          const startDate = new Date(trialistDetails.start_date);
          const isNewCustomer = startDate > cutoffDate;

          console.log('📅 Customer type check:', {
            startDate: trialistDetails.start_date,
            cutoffDate: cutoffDate.toISOString(),
            isNewCustomer
          });

          if (!currentAcademicYearStorage) return;
          const academicYear = currentAcademicYearStorage;

          // Check existing conversion methods for this school
          const filter = {
            where: {
              schoolid: schoolid,
            }
          };

          console.log('🔎 Fetching school-wide methods with filter:', filter);
          const existingMethods = await getClassConversionMethods(filter);
          console.log('📋 School-wide existing methods response:', existingMethods);

          const hasExistingSelection = existingMethods.some(
            method => method.academic_year === academicYear && method.transition_type !== 'mix_reassign_received'
          );

          console.log('🔍 School-wide selection check:', {
            hasExistingSelection,
            existingMethodsAcademicYears: existingMethods.map(m => ({
              academic_year: m.academic_year,
              teacherid: m.teacherid,
              transition_type: m.transition_type
            })),
            lookingForAcademicYear: academicYear
          });

          // If there's already an existing selection, don't do anything
          if (hasExistingSelection) {
            console.log('🚫 School-wide selection already exists - nothing to do');
            return;
          }

          if (isNewCustomer) {
            console.log('🆕 New customer detected - creating direct conversion method automatically');

            try {
              await createClassConversionMethod(teacherid, schoolid, 'direct');
              console.log('✅ Successfully created direct conversion method for new customer');
            } catch (error) {
              console.error("❌ Error creating direct conversion method for new customer:", error);
            }

            // Exit early - no modal needed for new customers
            return;
          }

          // OLD CUSTOMER LOGIC CONTINUES FROM HERE...
          console.log('👴 Old customer - proceeding with existing Senior Infant modal logic');

          // First check for higher-level roles that should be excluded
          const higherLevelRoles = ['SENCO', 'SET', 'principal', 'secretary'];
          const hasHigherLevelRole = teacherRoles.some(role =>
            higherLevelRoles.some(excludedRole =>
              role.toLowerCase().includes(excludedRole.toLowerCase())
            )
          );

          console.log('🎭 Role hierarchy check:', {
            teacherRoles,
            hasHigherLevelRole,
            matchingHigherRoles: teacherRoles.filter(role =>
              higherLevelRoles.some(excludedRole =>
                role.toLowerCase().includes(excludedRole.toLowerCase())
              )
            )
          });

          // If user has higher level roles, exit without showing modal
          if (hasHigherLevelRole) {
            console.log('🚫 User has higher-level role - excluding from Senior Infant modal');
            return;
          }

          // Only then check if they're a senior infant teacher
          const isSeniorTeacher = teacherRoles.some(role =>
            role.toLowerCase().includes('senior infant')
          );

          console.log('👩‍🏫 Teacher roles check:', {
            teacherRoles,
            isSeniorTeacher,
            matchingRoles: teacherRoles.filter(role =>
              role.toLowerCase().includes('senior infant')
            )
          });

          setIsSeniorInfantTeacher(isSeniorTeacher);

          if (!isSeniorTeacher) {
            console.log('❌ Not a Senior Infant teacher, exiting');
            return;
          }

          console.log('✅ Is Senior Infant teacher with no higher-level roles, checking for received submissions');

          // Store the existing methods in state for the modal
          setExistingConversionMethods(existingMethods);

          // Check for mix_reassign_received first
          const receivedSubmission = existingMethods.find(
            method => method.academic_year === academicYear && method.transition_type === 'mix_reassign_received'
          );

          if (receivedSubmission) {
            console.log('📥 Found mix_reassign_received submission:', receivedSubmission);

            // Get teacher info for the submission
            const submittingTeacher = teachers?.find(t => t.id === receivedSubmission.teacherid);

            setReceivedSubmissionData({
              date: receivedSubmission.date_submitted,
              teacherName: submittingTeacher?.name || 'Unknown Teacher',
              academicYear: receivedSubmission.academic_year || academicYear
            });

            setShowSeniorInfantReceivedModal(true);
            console.log('✅ Showing received submission modal');
            return;
          }

          // If we get here, it's an old customer senior infant teacher with no existing selection
          console.log('🚀 Old customer with no school-wide selection found - showing modal');
          setShowSeniorInfantModal(true);
          console.log('✅ Senior Infant modal state set to true');

        } catch (error) {
          console.error("❌ Error checking Senior Infant teacher status:", error);
        }
      } else {
        console.log('❌ Missing required data:', {
          hasSchoolId: !!schoolid,
          hasTeacherId: !!teacherid,
          hasTeacherRoles: teacherRoles.length > 0
        });
      }
    };

    checkIfSeniorInfantTeacher();
  }, [schoolid, teacherid, teacherRoles, classNumberModalResolved, showClassNumberModal, misSystemModalResolved, showMisSystemModal, teachers, trialistDetails, currentAcademicYearStorage]); // Added trialistDetails to dependencies

  useEffect(() => {
    console.log('🔄 classNumberModalResolved changed to:', classNumberModalResolved);

    if (classNumberModalResolved && !showClassNumberModal) {
      console.log('🎯 Conditions met for Senior Infant check - triggering in 200ms');

      // Small delay to ensure all state updates are complete
      const timer = setTimeout(() => {
        console.log('⏰ Timer triggered - checking Senior Infant conditions again');
        // This will trigger the main useEffect above due to dependency change
        // We can just log here since the main useEffect will handle the logic
      }, 200);

      return () => clearTimeout(timer);
    }
  }, [classNumberModalResolved, showClassNumberModal]);

  // const handleAlreadyDone = async () => {
  //   setMixReassignSubmitting(true);
  //   try {
  //     await createClassConversionMethod(teacherid, schoolid, 'mix_reassign');
  //     console.log('Teacher marked Mix & Reassign as completed');
  //   } catch (error) {
  //     console.error("Error saving completion status:", error);
  //   } finally {
  //     setMixReassignSubmitting(false);
  //   }
  // };

  // const handleDirectSelection = async () => {
  //   // This replaces the 'direct' logic from handleSeniorInfantOptionSelect
  //   await createClassConversionMethod(teacherid, schoolid, 'direct');
  //   console.log('Teacher selected: direct');
  // };

  // const handleMixReassignSelection = async () => {
  //   // This replaces the handleAlreadyDone function
  //   await createClassConversionMethod(teacherid, schoolid, 'mix_reassign_selected');
  //   console.log('Teacher marked Mix & Reassign as completed');
  // };

  // const handleNavigateToClassAdmin = () => {
  //   // This replaces the navigation logic from the original component
  //   navigate('/classadmindashboard', {
  //     state: {
  //       classDetails: { classes },
  //       teachers: { teachers },
  //       name: { name }
  //     }
  //   });
  // };

  // const handleCloseSeniorInfantModal = () => {
  //   setShowSeniorInfantModal(false);
  // };

  useEffect(() => {
    console.log('🚀 fetchPilotAndScreeningData useEffect triggered');
    console.log('📍 Current values:', { schoolid, countryid });

    const fetchPilotAndScreeningData = async () => {
      if (!schoolid || !countryid) {
        console.log('❌ Missing required values, returning early:', { schoolid, countryid });
        return;
      }

      try {
        // Fetch pilot data
        console.log('🔍 Fetching pilot data for schoolid:', schoolid);
        const pilotResponse = await getPilotBySchoolId(schoolid);
        console.log('📊 Pilot data:', pilotResponse);
        setPilotData(pilotResponse);

        // Fetch screening window status
        console.log('🔍 Fetching screening window for countryid:', countryid);

        let screeningResponse = await getScreeningWindowStatuses({
          countryid: countryid,
          active: true
        });

        console.log('📊 Screening window data (original):', screeningResponse);

        // If no results, fallback to default
        if (!screeningResponse || screeningResponse.length === 0) {
          console.log('⚠️ Using default countryid:', DEFAULT_COUNTRY_ID);
          screeningResponse = await getScreeningWindowStatuses({
            countryid: DEFAULT_COUNTRY_ID,
            active: true
          });
          console.log('📊 Screening window data (default):', screeningResponse);
        }

        setScreeningWindowData(screeningResponse);

      } catch (error) {
        console.error('❌ Error fetching pilot/screening data:', error);
      }
    };

    fetchPilotAndScreeningData();
  }, [schoolid, countryid]);

  
  return (
    <div>
      <Container fluid>
        <HeadingBanner
          name={`Welcome ${name}!`}
          isLoggedIn={true}
          cloud={true}
          schoolid={schoolid}
          teacherid={teacherid}
          pilotData={pilotData}
          screeningWindowData={screeningWindowData}
        />
        <Row className="vh-100">
          <Suspense fallback={<div>Loading Left Panel...</div>}>
            <LeftPanel />
          </Suspense>
          <Col sm={{ span: 10, offset: 2 }} className="blue-background">
            {aladdinGlobalEnabled && !aladdinNavigationAvailable && aladdinNextUpcoming && (
              <Alert variant="info" className="m-3">
                <strong>{aladdinNextUpcoming.assessmentName} Aladdin Export</strong>
                <div>{aladdinNextUpcoming.message}</div>
                {aladdinNextUpcoming.availableFrom && (
                  <div>
                    Scheduled availability: {formatAladdinAvailabilityDate(aladdinNextUpcoming.availableFrom)}
                  </div>
                )}
              </Alert>
            )}
            {loading ? (
              <div className="spinner-container">
                <div className="big-ball-spinner"></div>
              </div>
            ) : (
              <>
                {classes.length === 0 ? (
                  <Row>
                    <Suspense fallback={<div>Loading Intro Video...</div>}>
                      <IntroVideoButton />
                    </Suspense>
                    <Col className="col-3"></Col>
                    <Suspense
                      fallback={
                        <div>Loading Additional Colleagues Button...</div>
                      }
                    >
                      <AdditionalColleaguesButtonMD2
                        rollNumber={rollNumber}
                        teacherEmail={teacherEmail}
                      />
                    </Suspense>
                  </Row>
                ) : (
                  <Row className="invite-colleagues-row-position">
                    {/* DONAL */}
                    {/* if time.now() > purchased.next_payment_date etc  */}
                    <FreeTrialBanner
                      schoolid={schoolid}
                      teacherName={name}
                      freeDaysLeft={freeDaysLeft}
                      trialistDetails={trialistDetails}
                      pilotData={pilotData}
                    />

                    <div className="additional-colleague-button ">
                      <div className="assessment-reminder-content hide-assessment-banner">
                        <Link
                          className="ass-heading-link "
                          to={`/assessmentsdashboard`}
                          state={{
                            classDetails: { classes },
                            teachers: { teachers },
                            name: { name },
                          }}
                        >
                          <img
                            src="../assets/imgs/spring-icon.png"
                            className="assessment-reminder-card-img"
                            alt="Colleague Icon"
                          />
                          <p className="ass-heading-card-text">
                            Midpoint Assessment Season is Here! <br /> Time to
                            Assign and Shine!
                          </p>
                          <img
                            src="../assets/imgs/spring-icon.png"
                            className="assessment-reminder-card-img"
                            alt="Colleague Icon"
                          />
                        </Link>
                      </div>
                    </div>

                    {/* <VideoModal
                      buttonText="📺 Click here to see useful video guides on how to use the Teacher Dashboard"
                      modalTitle="How to use the Teacher Dashboard"
                      videos={[
                        {
                          title: "Navigating the Teacher Dashboard",
                          iframe: "https://www.youtube.com/embed/Gd9uNam1YqA?si=rg7kojO760MBHWvk"
                        },
                        {
                          title: "How to Share a Class with a Colleague",
                          iframe: "https://www.youtube.com/embed/WI2EiLKhxo0?si=n4pEHXQzG4ZZU7Ne"
                        }
                        ,
                        {
                          title: "How to Invite Colleagues",
                          iframe: "https://www.youtube.com/embed/ZzcP4ZAVOBg?si=4PR8xUsxIDPZBkpA"
                        }
                        ,
                        {
                          title: "20 minute video",
                          iframe: "https://www.youtube.com/embed/1cYyO_Yv7YE?si=AqQIvZ-tZd-ANLS1"
                        }
                      ]}
                    /> */}

                    {homeMessage && (
                      homeMessage.hyperlink ? (
                        <a href={homeMessage.hyperlink} target="_blank" rel="noopener noreferrer">
                          <button
                            style={buttonStyle}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#FF6B35';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = '#FF6B35';
                            }}
                            onFocus={(e) => {
                              e.target.style.outline = 'none';
                            }}
                          >
                            {homeMessage.text}
                          </button>
                        </a>
                      ) : homeMessage.route ? (
                        <Link to={homeMessage.route}>
                          <button
                            style={buttonStyle}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#FF6B35';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = '#FF6B35';
                            }}
                            onFocus={(e) => {
                              e.target.style.outline = 'none';
                            }}
                          >
                            {homeMessage.text}
                          </button>
                        </Link>
                      ) : null
                    )}

                    <Col>
                      <Suspense
                        fallback={
                          <div>Loading Additional Colleagues Button...</div>
                        }
                      >
                        <AdditionalColleaguesButtonMD
                          rollNumber={rollNumber}
                          teacherEmail={teacherEmail}
                        />
                      </Suspense>
                    </Col>
                    {/* Invite a School is retained for possible restoration.
                    <Col>
                      <Suspense
                        fallback={<div>Loading Refer A Friend Button...</div>}
                      >
                        <ReferAFriendButton
                          rollNumber={rollNumber}
                          teacherEmail={teacherEmail}
                          teacherid={teacherid}
                          name={name}
                        />
                      </Suspense>
                    </Col>
                    */}
                  </Row>
                )}
                <Row className="masterdash-row-position">
                  <Col className="col-3">
                    <Card className="masterdash-card-detail">
                      <Link
                        className="link"
                        to={`/classadmindashboard`}
                        state={{
                          classDetails: { classes },
                          teachers: { teachers },
                          name: { name },
                          rollNumber: { rollNumber },
                        }}
                      >
                        <img
                          src="./assets/imgs/admin-icon.png"
                          className="master-class-card-img"
                          alt="Classrooms Icon"
                        ></img>
                        <p className="class-card-text">Classrooms</p>
                      </Link>
                    </Card>
                  </Col>
                  {classes.length === 0 ? (
                    <Suspense
                      fallback={<div>Loading ALpaca Info Gesture...</div>}
                    >
                      <AlpacaInfoGesture speechText={speechText} />
                    </Suspense>
                  ) : (
                    <>
                      <Col className="col-3">
                        <Card className={`masterdash-card-detail`}>
                          <Link
                            className="link"
                            to={`/assessmentsdashboard`}
                            state={{
                              classDetails: { classes },
                              teachers: { teachers },
                              name: { name },
                            }}
                          >
                            <div>
                              <img
                                src="./assets/imgs/assignassessments-icon.png"
                                className="master-class-card-img"
                                alt="Assign Assessments Icon"
                              ></img>
                              <p className="class-card-text">Assign Screener</p>
                            </div>
                          </Link>
                        </Card>
                      </Col>

                      <Col className="col-3">
                        <Card className="masterdash-card-detail">
                          <Link
                            className="link"
                            to={`/qrdashboard`}
                            state={{
                              classDetails: { classes },
                              teachers: { teachers },
                              name: { name },
                            }}
                          >
                            <img
                              src="./assets/imgs/qrs-icon.png"
                              className="master-class-card-img"
                              alt="Student QRs Icon"
                            ></img>
                            <p className="class-card-text">Student QRs</p>
                          </Link>
                        </Card>
                      </Col>
                      <Col className="col-3">
                        <Card className="masterdash-card-detail">
                          {teacherRoles?.some((role) =>
                            ["SENCO", "SET", "Special Educator/SET"].includes(role)
                          ) ? (
                            <a
                              href="#"
                              className="link"
                              onClick={(e) => {
                                e.preventDefault(); // Prevent default link behavior
                                handleSENCOView();
                              }}
                            >
                              <img
                                src="./assets/imgs/viewresults-icon.png"
                                className="master-class-card-img"
                                alt="View Results Icon"
                              ></img>
                              <p className="class-card-text">View Results</p>
                            </a>
                          ) : (
                            <Link
                              className="link"
                              to={`/resultsdashboard`}
                              state={{
                                classDetails: { classes },
                                teachers: { teachers },
                                name: { name },
                              }}
                            >
                              <img
                                src="./assets/imgs/viewresults-icon.png"
                                className="master-class-card-img"
                                alt="View Results Icon"
                              ></img>
                              <p className="class-card-text">View Results</p>
                            </Link>
                          )}
                        </Card>
                      </Col>
                    </>
                  )}
                </Row>
              </>
            )}
          </Col>
        </Row>
      </Container>

      {isPortrait && <OrientationPrompt />}

      {/* Class Number Confirmation Modal */}
      {/* <ClassNumberModal
        show={showClassNumberModal}
        onClose={handleCloseClassNumberModal}
        onSubmit={handleClassNumberSubmit}
      /> */}

      {/* <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        dialogClassName="fun-vibrant-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assessment Window Closed</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          The current assessment window is now closed. We will be reopening the
          ALPACA assessment for the <strong>End of Year</strong> assessment
          window on the <strong>7th May</strong>.
        </Modal.Body>
        <Modal.Body>Thank you for your understanding.</Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}

      {/* Trial Ended Modal */}
      <Modal show={showTrialEndedModal} onHide={handleCloseTrialEndedModal}>
        <Modal.Header closeButton>
          <Modal.Title>Access Restricted</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your free trial has ended. To continue using ALPACA's features, please
          purchase a subscription.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseTrialEndedModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* <ClassTransitionModal
        show={showSeniorInfantModal}
        onClose={() => setShowSeniorInfantModal(false)}
        onDirectSelection={handleDirectSelection}
        onMixReassignSelection={handleMixReassignSelection}
        onNavigateToClassAdmin={handleNavigateToClassAdmin}
        existingMethods={existingConversionMethods} // Add this line
      />

      <ReceivedListModal
        show={showSeniorInfantReceivedModal}
        onClose={() => setShowSeniorInfantReceivedModal(false)}
        submissionData={receivedSubmissionData}
      /> */}

      {/* <Modal
        show={showMisSystemModal}
        onHide={handleCloseMisSystemModal}
        backdrop={misSystemSuccess || misSystemError ? true : "static"}
        keyboard={misSystemSuccess || misSystemError ? true : false}
        centered
        size="md"
      >
        <Modal.Header closeButton={!!(misSystemSuccess || misSystemError)}>
          <Modal.Title>Confirm your School's MIS System</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {misSystemError && (
            <div className="alert alert-danger">
              {misSystemError}
            </div>
          )}

          {misSystemSuccess && (
            <div className="alert alert-success">
              {misSystemSuccess}
            </div>
          )}

          {!misSystemSuccess && !misSystemError && (
            <>
              <p><strong>Please help us identify which MIS (Management Information System) your school uses.</strong></p>
              <p>This helps us provide better integration and support for your school's data management.</p>

              <div className="mb-4">
                <label className="form-label"><strong>Which MIS system does your school use?</strong></label>
                <select
                  className="form-select"
                  value={selectedMisSystem}
                  onChange={(e) => setSelectedMisSystem(e.target.value)}
                >
                  <option value="">-- Please select --</option>
                  {misSystemOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>
            </>
          )}
        </Modal.Body>

        {!misSystemSuccess && !misSystemError && (
          <Modal.Footer style={{ justifyContent: 'space-between' }}>
            <button
              className="btn btn-secondary"
              onClick={handleMisSystemDontKnow}
              disabled={misSystemSubmitting}
            >
              Don't Know
            </button>
            <button
              className="confirm-button"
              onClick={handleMisSystemSubmit}
              disabled={misSystemSubmitting || !selectedMisSystem}
            >
              {misSystemSubmitting ? 'Submitting...' : 'Submit'}
            </button>
          </Modal.Footer>
        )}
      </Modal> */}

    </div>
  );
}

export default MasterDashboard;
